import { useMutation, useQueryClient } from '@tanstack/react-query';
import { API } from 'utils/globalApiServices';
import { toastFlashMessage } from 'utils';

const mutationFn = async ({ url_video, response_uuid, session_uuid }) => {
  const url = `v2/roleplay/${response_uuid}/scenario/update/`;
  const data = await API.post(url, { url_video, session_uuid });
  return data;
};

const useScenarioUpdateMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn,
    onSuccess: (response, data) => {
      toastFlashMessage(response?.message, 'success');
      queryClient.invalidateQueries(['REALPLAY_INFO', data.roleplay_id]);
    },
  });
};

export default useScenarioUpdateMutation;
